import { ElementNode, $createTextNode } from 'lexical';

export class ColorNode extends ElementNode {
  __color;

  // eslint-disable-next-line default-param-last
  constructor(color = '#000000', nodeKey) {
    // Provide default color so constructor can be called without arguments
    super(nodeKey);
    this.__color = color;
  }

  static getType() {
    return 'color';
  }

  static clone(node) {
    return new ColorNode(node.__color, node.__key);
  }

  static importJSON(serializedNode) {
    // eslint-disable-next-line no-use-before-define
    const node = $createColorNode('', serializedNode.color);
    // Lexical will handle importing children if they exist
    return node;
  }

  exportJSON() {
    const json = {
      type: 'color',
      version: 1,
      color: this.__color,
    };

    // Lexical will handle serializing children
    const children = this.getChildren();
    if (children.length > 0) {
      // Let Lexical handle the serialization
      // eslint-disable-next-line no-underscore-dangle
      json.children = children.map((child) => child.exportJSON());
    } else {
      json.children = [];
    }

    return json;
  }

  createDOM() {
    const span = document.createElement('span');
    span.style.color = this.__color;
    return span;
  }

  updateDOM(prevNode, dom) {
    if (prevNode.__color !== this.__color) {
      // eslint-disable-next-line no-param-reassign
      dom.style.color = this.__color;
    }
    return false;
  }

  getColor() {
    return this.__color;
  }

  setColor(color) {
    const writable = this.getWritable();
    writable.__color = color;
  }
}

// Factory function
export function $createColorNode(text = '', color = '#000000') {
  const node = new ColorNode(color);
  if (text) {
    node.append($createTextNode(text));
  }
  return node;
}

export function $isColorNode(node) {
  return node instanceof ColorNode;
}
